/**
 * Created by Kirill Mashchenko on 12.07.19.
 */

/**
 * @class Layer for draftsman robot settings.
 * @extends PlayerRobotSettingsLayer
 * @constructor
 * @param {pm.AbstractRobot} robot Robot which settings need to display.
 */
var DraftsmanRobotSettingsLayer = PlayerRobotSettingsLayer.extend(/** @lends DraftsmanRobotSettingsLayer# */{

	ctor: function(robot)
	{
		this._super(robot);

		this._label.setString(LocalizedString("Draftsman") + " " + robot.id + ", " + LocalizedString("Pattern") + " " + robot.parentLevel.programData[robot.groupID].currentIndex);
	}
});
